"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _advanceWidth = _interopRequireDefault(require("../run/advanceWidth"));
/**
 * Returns attributed string advancewidth
 *
 * @param {Object} attributed string
 * @return {number} advance width
 */


var advanceWidth = function advanceWidth(attributeString) {
  var reducer = function reducer(acc, run) {
    return acc + (0, _advanceWidth["default"])(run);
  };

  return attributeString.runs.reduce(reducer, 0);
};

var _default = advanceWidth;
exports["default"] = _default;